import {Component, Injector, Input, OnInit} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {ScorecardService} from "../../_services/scorecard.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'admin-user-assessment',
    templateUrl: './user-man-assessment.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManAssessmentComponent extends BasePageComponentDirective<any> implements OnInit {
    scorecards: any[] = [];
    attendanceTypes: any = {};
    @Input() user: any;
    userId: any = null;

    constructor(
        injector: Injector,
        private scorecardService: ScorecardService,
    ) {
        super(injector);
    }

    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['competitionLevel'];
        this.scorecardService.getAll(this.pageQuery, this.userId).then(r => {
            this.scorecards = r.content;
            this.page.emit(r);

        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.userId = this.activatedRoute.snapshot.params.id;
        this.query();

    }

    newScorecard() {
        this.router.navigate([`office/user/scorecard/0/${this.userId}/new`]).then()
    }

    deleteScorecard(d: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                buttonOkLabel: 'Yes, Delete',
                buttonCancelLabel: 'Cancel',
                message: ``,
                subMessage: `Are you sure you want to delete "${d.competitionLevel}" from user scorecard? This action cannot be undone.`,
                theme: 'dark'
            }
        })

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.scorecardService.deleteScorecard(d.id, this.user.id).then(_ => {
                    this.snackBar.open('Scorecard has been deleted successfully', null, {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'right'
                    });
                    this.query();
                })
            }
        });
    }

    editScorecard(d: any) {
        this.router.navigate([`office/user/scorecard/${d.id}/${this.userId}/edit`]).then()
    }
}
